export default __webpack_public_path__ + "static/media/concluded_resumes.d8584e05.svg";